// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-scrollbar .el-scrollbar__view {\n  height: 100%;\n}\n.menu-info .menu-contorl {\n  line-height: 52px;\n  font-size: 20px;\n  display: table-cell;\n  vertical-align: middle;\n}", ""]);
// Exports
module.exports = exports;
